import type { ReactNode } from 'react';

import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { Box, ButtonBase, TableCell } from '@/shared/ui';

type Props = {
  open: boolean;
  disabled: boolean;
  onToggle: () => void;
  children?: ReactNode;
};

const ExpandCell = ({ open, disabled, onToggle, children }: Props) => (
  <TableCell
    sx={theme => ({
      p: 0,
      pl: 1,
      pr: 1,
      borderLeft: `2px solid ${open ? theme.palette.gx.highlight : 'transparent'}`
    })}
  >
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ButtonBase
        aria-label='expand row'
        disabled={disabled}
        style={{ paddingRight: 5 }}
        onClick={onToggle}
      >
        <KeyboardArrowUp
          sx={{
            fontSize: 14,
            transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform cubic-bezier(0.5, 0, 0.5, 1) 0.1s'
          }}
        />
      </ButtonBase>
      {children}
    </Box>
  </TableCell>
);

export default ExpandCell;
